<template>
  <div class="animated fadeIn">
    <!-- Barra de pesquisa no topo -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="d-flex align-items-center" style="gap: 0.5rem;">
          <div class="flex-grow-1">
            <input
              type="text"
              class="form-control"
              placeholder="Digite o Nome da Tag"
              v-model="searchText"
              @keyup.enter="onQuickSearch"
            />
          </div>
          <button
            type="button"
            class="btn btn-third"
            @click="onQuickSearch"
            v-b-tooltip.hover
            title="Pesquisar"
          >
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>
    </div>
    <Tables ref="tableGrid"
            :columns="['NOME', 'ABREVIAÇÃO', 'COR', 'COR DO TEXTO', $lang.Common.DataTable.Actions]"
            :showNew="true"
            :showSearch="false"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :value="obj.nome ? obj.nome.toUpperCase() : ''" :status="1" />
        <td class="text-center">
          <span v-if="obj.abreviacao">
            {{ obj.abreviacao.toUpperCase() }}
          </span>
          <span v-else class="text-muted">-</span>
        </td>
        <td class="text-center">
          <span
            v-if="obj.cor"
            class="badge badge-pill d-inline-block"
            :style="{
              backgroundColor: obj.cor || '#FFFFFF',
              color: obj.corTexto || '#000000',
              minWidth: '80px',
              padding: '5px 10px',
              border: '1px solid #dee2e6',
              fontSize: '12px'
            }"
          >
            {{ obj.cor }}
          </span>
          <span v-else class="text-muted">-</span>
        </td>
        <td class="text-center">
          <span
            v-if="obj.corTexto"
            class="badge badge-pill d-inline-block"
            :style="{
              backgroundColor: obj.corTexto || '#FFFFFF',
              color: obj.cor || '#000000',
              minWidth: '80px',
              padding: '5px 10px',
              border: '1px solid #dee2e6',
              fontSize: '12px'
            }"
          >
            {{ obj.corTexto }}
          </span>
          <span v-else class="text-muted">-</span>
        </td>
        <td class="text-center">
          <i
            v-on:click="onEdit(obj)"
            class="fa fa-edit text-third icone-grid cursor-pointer"
            v-b-tooltip.hover
            :title="$lang.Common.Tooltip.ButtonEdit"
            style="margin-right: 10px;"
          ></i>
          <b-dropdown
            variant="link"
            size="sm"
            no-caret
          >
            <template slot="button-content">
              <i class="fas fa-trash-alt text-secundary icone-grid"></i>
              <span class="sr-only">{{ $lang.Common.Buttons.Delete }}</span>
            </template>
            <b-dropdown-header>
              <strong>{{ $lang.Common.ConfirmDelete }}</strong>
            </b-dropdown-header>
            <b-dropdown-item
              href="javascript:void(0);"
              v-on:click="onDelete(obj)"
            >
              {{ $lang.Common.Yes }}
            </b-dropdown-item>
            <b-dropdown-item href="javascript:void(0);">
              {{ $lang.Common.No }}
            </b-dropdown-item>
          </b-dropdown>
        </td>
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import TagRepository from '@/shared/http/repositories/configurations/tag.js'

export default {
  name: 'TagList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: {},
      searchText: ''
    }
  },
  methods: {
    onQuickSearch () {
      // Pesquisa rápida usando a barra de pesquisa do topo
      if (this.searchText && this.searchText.trim()) {
        this.filters = { nome: this.searchText.trim() }
      } else {
        this.filters = {}
      }
      this.onLoad()
    },
    onLoad () {
      loading.push()
      // Se houver filtro de nome, usa o método Search, senão usa GetAllPaging
      if (this.filters.nome) {
        TagRepository.Search(this.filters.nome, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        TagRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      this.$bvModal.msgBoxConfirm(
        `Deseja excluir a tag "${obj.nome}"?`,
        {
          title: 'Confirmar Exclusão',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )
        .then(value => {
          if (value) {
            loading.push()
            TagRepository.Delete(obj.id)
              .then((response) => {
                loading.pop()
                toast.success(this.$lang.Common.Alerts.Success)
                this.onLoad()
              })
              .catch((err) => {
                loading.pop()
                // Verifica se é erro de constraint (tag em uso)
                if (err && err.data && err.data.errors &&
                    Array.isArray(err.data.errors) && err.data.errors.length > 0) {
                  const errorMessage = err.data.errors[0].message
                  // Verifica se é erro de ConstraintViolationException na exclusão
                  if (errorMessage && (
                    errorMessage.includes('ConstraintViolationException') ||
                      errorMessage.includes('could not execute batch') ||
                      errorMessage.includes('constraint')
                  )) {
                    // Exibe mensagem amigável em amarelo (warning)
                    toast.warning('Esta tag não pode ser excluída pois está em uso.', 'Atenção')
                    return // Retorna para não chamar onException
                  }
                }
                // Se não for erro de constraint, usa o tratamento padrão
                this.onException(err)
              })
          }
        })
        .catch(err => {
          void err
          // An error occurred
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/board/tag/components/list/taglist.vue